module.exports = __webpack_public_path__ + "img/sainuofei.09b23496.png";